import { call, takeEvery, select } from 'redux-saga/effects';
import {
  CREATE_TEXT_ELEMENT,
  SET_SHOW_ELEMENT_MODAL,
  LOCK_ELEMENTS,
  UNLOCK_ELEMENTS,
  SET_ELEMENTS_TIMINGS
} from 'JS/actionCreators/scribeActions';
import { getScribeById } from 'JS/sagas/selectors';
import {
  TRACK_FREE_TRANSFORM_SELECTED,
  TRACK_FLIP_ELEMENT,
  TRACK_SELECT_FONT,
  TRACK_ALIGN_TEXT,
  TRACK_BOLD_TEXT,
  TRACK_ITALIC_TEXT,
  TRACK_CHANGE_ELEMENT_COLOR,
  TRACK_DELETE_ELEMENT
} from 'JS/actionCreators/trackingActions';

import { track } from '../mixpanelProvider';

function* trackAddText({ scribeId }) {
  yield call(track, 'Add Text To Canvas', { 'Scribe ID': scribeId });
}

function* trackSetShowElementModal({ scribeId, elementType }) {
  if (elementType === 'image') {
    yield call(track, 'Open Image Modal', { 'Scribe ID': scribeId });
  }
  if (elementType === 'shape') {
    yield call(track, 'Open Shape Modal', { 'Scribe ID': scribeId });
  }
}

function* trackLockElements({ type, scribeId, elementIds, eventTrigger }) {
  const eventName = type === UNLOCK_ELEMENTS ? 'Unlock Element' : 'Lock Element';

  if (elementIds.length > 1) {
    yield call(track, eventName, { 'Scribe ID': scribeId, 'Element Type': 'Multiple', 'Event Trigger': eventTrigger });
  } else {
    const scribe = yield select(state => getScribeById(state, scribeId));
    const element = scribe.elements.find(el => el.id === elementIds[0]);
    if (element) {
      yield call(track, eventName, {
        'Scribe ID': scribeId,
        'Element Type': element.type,
        'Event Trigger': eventTrigger
      });
    }
  }
}

function* trackDeleteElements({ scribeId, eventTrigger }) {
  yield call(track, 'Delete Element', { 'Scribe ID': scribeId, 'Event Trigger': eventTrigger });
}

function* trackFreeTransformSelected({ selected, elementType, scribeId }) {
  const action = selected ? 'Select Free Transform Element' : 'Deselect Free Transform Element';
  yield call(track, action, { 'Scribe ID': scribeId, 'Element Type': elementType });
}

function* trackFlipElement({ direction, elementType, scribeId }) {
  const action = direction === 'vertical' ? 'Flip Vertically Element' : 'Flip Horizontally Element';
  yield call(track, action, { 'Scribe ID': scribeId, 'Element Type': elementType });
}

function* trackSelectFont({ fontName, scribeId }) {
  yield call(track, 'Select Font', { 'Font Name': fontName, 'Scribe ID': scribeId });
}

function* trackAlignText({ alignment, scribeId }) {
  yield call(track, 'Align Text', { Alignment: alignment, 'Scribe ID': scribeId });
}

function* trackBoldText({ selected, scribeId }) {
  yield call(track, 'Bold Text', { 'Scribe ID': scribeId, [selected ? 'Select' : 'Deselect']: true });
}

function* trackItalicText({ selected, scribeId }) {
  yield call(track, 'Italic Text', { 'Scribe ID': scribeId, [selected ? 'Select' : 'Deselect']: true });
}

function* trackChangeElementColor({
  elementType,
  colorType,
  gradientDirection,
  colorTab,
  opacity,
  scribeId,
  colorLayer,
  imageName
}) {
  yield call(track, 'Set Element Colour', {
    'Element Type': elementType,
    'Colour Type': colorType,
    'Colour Tab': colorTab,
    'Gradient Direction': gradientDirection,
    'Opacity (%)': opacity,
    'Scribe ID': scribeId,
    'Image Name': imageName,
    'Image Recolor Type': colorLayer
  });
}

function* trackSetElementsTimings({ scribeId, elementIds, property, value }) {
  const isAnimationTime = property === 'animationTime';
  const action = isAnimationTime ? 'Set Animation Timing' : 'Set Pause Timing';

  let elementType;
  if (elementIds.length > 1) {
    elementType = 'Multiple';
  } else {
    const scribe = yield select(state => getScribeById(state, scribeId));
    const element = scribe.elements.find(el => el.id === elementIds[0]);
    elementType = element.type;
  }

  yield call(track, action, {
    'Element Type': elementType,
    'Scribe ID': scribeId,
    [isAnimationTime ? 'Animation Timing (Seconds)' : 'Pause Timing (seconds)']: value
  });
}

export default function* trackCanvasEvents() {
  yield takeEvery(CREATE_TEXT_ELEMENT, trackAddText);
  yield takeEvery(SET_SHOW_ELEMENT_MODAL, trackSetShowElementModal);
  yield takeEvery([LOCK_ELEMENTS, UNLOCK_ELEMENTS], trackLockElements);
  yield takeEvery(TRACK_FREE_TRANSFORM_SELECTED, trackFreeTransformSelected);
  yield takeEvery(TRACK_FLIP_ELEMENT, trackFlipElement);
  yield takeEvery(TRACK_SELECT_FONT, trackSelectFont);
  yield takeEvery(TRACK_ALIGN_TEXT, trackAlignText);
  yield takeEvery(TRACK_BOLD_TEXT, trackBoldText);
  yield takeEvery(TRACK_ITALIC_TEXT, trackItalicText);
  yield takeEvery(TRACK_CHANGE_ELEMENT_COLOR, trackChangeElementColor);
  yield takeEvery(SET_ELEMENTS_TIMINGS, trackSetElementsTimings);
  yield takeEvery(TRACK_DELETE_ELEMENT, trackDeleteElements);
}
